import { render, staticRenderFns } from "./InventoryItemAddEditModal.vue?vue&type=template&id=15832056&"
import script from "./InventoryItemAddEditModal.vue?vue&type=script&lang=js&"
export * from "./InventoryItemAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports